import { AxiosResponse } from "axios"

export default function responseInteceptor(response: AxiosResponse) {
	if (response.status >= 400) {
		return Promise.reject(response)
	}
	return response
}
